// extracted by mini-css-extract-plugin
export var billingAddress = "_rs-g";
export var contactInfo = "_rs-d";
export var customerInfoContainer = "_rs-c";
export var customerInfoContainerMobile = "_rs-h";
export var customerInfoRow = "_rs-a";
export var customerInfoSection = "_rs-b";
export var fullWidthDividerMobile = "_rs-i";
export var imageContainer = "_rs-1";
export var paymentMethod = "_rs-e";
export var priceText = "_rs-6";
export var priceTextMobile = "_rs-7";
export var product = "_rs-0";
export var productImage = "_rs-2";
export var productInfo = "_rs-4";
export var productMobile = "_rs-9";
export var productTitle = "_rs-8";
export var quantityBadge = "_rs-3";
export var quantityText = "_rs-5";
export var shippingAddress = "_rs-f";